// Map API endpoints here

export default $axios => ({
  getModules({ type, assignmentId, offerId, location }, rootState) {
    const { isPreview = false } = rootState.offer;
    const { id: partnerUserId } = rootState.partnerUser;

    const url = isPreview
      ? `/api/preview/modules/assignment/${type}/assignmentId/${assignmentId}/location/${location ||
          'pass'}`
      : `/api/partnerUser/${partnerUserId}/modules/assignment/${type}/assignmentId/${assignmentId}/location/${location ||
          'pass'}?offerId=${offerId}`;

    return $axios.get(url);
  },

  // https://bandwango-stage.herokuapp.com/api-docs#get-module-data
  // GET /api/partnerUser/{partnerUser}/moduleAssignment/{moduleAssignment}
  // https://bandwango-stage.herokuapp.com/api-docs#get-module-preview-data
  // GET /api/preview/moduleAssignment/{moduleAssignment}
  getData({ moduleAssignment, params }, rootState) {
    const { isPreview = false } = rootState.offer;
    const { id: partnerUserId } = rootState.partnerUser;

    const url = isPreview
      ? `/api/preview/moduleAssignment/${moduleAssignment}`
      : `/api/partnerUser/${partnerUserId}/moduleAssignment/${moduleAssignment}`;

    return $axios.get(url, { params });
  }
});

// GET /api/partnerUser/{partnerUser}/moduleAssignment/{moduleAssignment}
